// Copyright (c) 2016 Deere & Company

import DealerRecommendationLeaveAor from '@deere/cps-it.warranty-model-factory/lib/dealer-recommendation-leave-aor';
import t from 'tcomb';

const DealerRecommendationList = t.struct({
    elements: t.list(DealerRecommendationLeaveAor, 'DealerRecommendation'),
    totalElements: t.Number,
    totalPages: t.Number
}, {
    name: 'DealerRecommendationList',
    strict: true
});

export const getDefaultState = () => new DealerRecommendationList({elements: [], totalElements: 0, totalPages: 0});

export default DealerRecommendationList;



// WEBPACK FOOTER //
// ./src/product/dealer-recommendations/state/dealer-recommendation-list.js